import React, { useEffect, useRef, useState } from 'react';

const QuoteWidget = () => {
  const containerRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    
    // Load NinjaQuoter script
    const script = document.createElement('script');
    script.className = 'nqwq EeL6';
    script.type = 'text/javascript';
    script.src = 'https://quoter.ninjaquoter.com/EeL6WBibRMjt5CVRc53k8woY.js';
    script.async = true;
    
    script.onload = () => {
      setIsLoaded(true);
    };
    
    if (container) {
      container.appendChild(script);
    }

    return () => {
      if (container && script.parentNode === container) {
        container.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="ninja-quoter-wrapper w-full max-w-md mx-auto">
      <div className="bg-white rounded-xl shadow-2xl overflow-hidden">
        <div ref={containerRef} data-testid="ninja-quoter-widget" className="w-full">
          {/* NinjaQuoter widget loads here */}
          {!isLoaded && (
            <div className="flex flex-col items-center justify-center min-h-[400px] text-slate-600 text-center p-6">
              <div className="animate-pulse mb-4">
                <svg className="w-12 h-12 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              <p className="text-sm">Loading quote comparison tool...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuoteWidget;
